var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { Loading } from 'element-ui';
import OperationReportService from '../../api/OperationReportService';
import { billDefaultDate } from "../../helper/defaultDate";
import { UrlHelper } from '../../helper/UrlWrapper';
import { pageKeys, recordSelector, useTableSumData } from './hooks';
import TableList from './components/TableList.vue';
import CommonService from "../../api/CommonService";
var OperationReport = (function (_super) {
    __extends(OperationReport, _super);
    function OperationReport() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.service = OperationReportService.getInstance();
        _this.fetchAction = _this.service.getTtiuphDetail;
        _this.summaryListData = [];
        _this.listData = [];
        _this.tableHeight = document.documentElement.clientHeight - 220;
        _this.filter = {
            s_time: billDefaultDate().Start.format('yyyy-MM-dd'),
            e_time: billDefaultDate().End.format('yyyy-MM-dd'),
            keyword: '',
            sort_field: '',
            sort_type: 'DESC',
            type: 1,
        };
        _this.total = 0;
        _this.templateType = "11";
        _this.sortColumns = [];
        _this.showSummary = false;
        _this.options = [
            {
                id: 1,
                label: "邀请数"
            },
            {
                id: 3,
                label: "服务数"
            },
            {
                id: 6,
                label: "新增下单数"
            },
            {
                id: 7,
                label: "下单数"
            },
            {
                id: 8,
                label: "销售额"
            },
            {
                id: 9,
                label: "回款额"
            }
        ];
        return _this;
    }
    OperationReport.prototype.getChange = function (newVal, oldVal) {
        this.showSummary = [8, 9].includes(newVal) ? true : false;
        if (newVal) {
            recordSelector({ filterType: newVal });
            switch (newVal) {
                case 1:
                    this.templateType = 11;
                    break;
                case 3:
                    this.templateType = 12;
                    break;
                case 6:
                    this.templateType = 13;
                    break;
                case 7:
                    this.templateType = 14;
                    break;
                case 8:
                    this.templateType = 15;
                    break;
                case 9:
                    this.templateType = 16;
                    break;
            }
        }
        console.log(8888, this.templateType);
    };
    OperationReport.prototype.created = function () {
        this.commonService = CommonService.getInstance();
    };
    OperationReport.prototype.search = function () {
        var _this = this;
        this.$refs.pagination && this.$refs.pagination.clear();
        this.$nextTick(function () {
            _this.$refs.TableList.fetch();
        });
    };
    OperationReport.prototype.getList = function (pager) {
        var _this = this;
        if (pager === void 0) { pager = { page: 1, start: 0, limit: 20 }; }
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service
            .getTtiuphDetail(Object.assign({}, this.filter, pager))
            .then(function (res) {
            loadingInstance.close();
            console.log(res.data);
            _this.summaryListData = Array.isArray(res.data.data) ? res.data.data : res.data.data;
            _this.total = res.data.total;
        })
            .catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message);
        });
    };
    OperationReport.prototype.sortChange = function (_a) {
        var column = _a.column, prop = _a.prop, order = _a.order;
        if (!prop) {
            this.filter.sort_field = '';
            this.filter.sort_type = '';
        }
        else {
            this.filter.sort_field = prop;
            this.filter.sort_type = order === 'ascending' ? 'ASC ' : 'DESC';
        }
        this.getList();
    };
    OperationReport.prototype.pageChange = function (pager) {
        this.getList(pager);
    };
    OperationReport.prototype.exportResult = function () {
        var _this = this;
        var url = "supplierclientapi/performance/detail_export?s_time=" + this.filter.s_time
            + '&e_time=' + this.filter.e_time
            + '&keyword=' + this.filter.keyword
            + '&sort_field=' + this.filter.sort_field
            + '&sort_type=' + this.filter.sort_type
            + '&type=' + this.filter.type;
        url = UrlHelper.addParam(url, 'token', this.user.token);
        this.commonService.exportCheck(url)
            .then(function (res) {
            location.href = url;
            window._czc.push(["_trackEvent", '业绩明细', '业绩明细导出']);
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
    };
    OperationReport.prototype.setSummary = function (params) {
        return useTableSumData(params, pageKeys['detail']);
    };
    __decorate([
        Watch('filter.type')
    ], OperationReport.prototype, "getChange", null);
    OperationReport = __decorate([
        Component({
            computed: __assign({}, mapGetters({
                user: 'user',
                openedCodeData: 'openedCodeData',
            })),
            components: {
                TableList: TableList
            },
            methods: {},
        })
    ], OperationReport);
    return OperationReport;
}(Vue));
export default OperationReport;
